import { Client } from "@seneca/client-library";

type ResponseBody = {
  static?: { [key: string]: { value: boolean } };
  release?: { [key: string]: { value: boolean } };
  abTest?: { [key: string]: { value: string } };
};

export default class FeatureFlagsServiceClient extends Client {
  async fetchFeatureFlags() {
    const url = `${this.url}/api/flags`;
    const expectedResponses = [200];

    const response = await this.requestMaker.makeRequest<ResponseBody>(
      url,
      { method: "GET" },
      expectedResponses
    );

    return response.json;
  }
}
